import app from '@/app';
import templateUrl from './iqdCalculation-search.html';

/* @ngInject */
function IqdCalculationSearchController(
	$controller,
	$state,
	$http,
	DialogService,
	IqdCalculation,
	WarnIqdService,
	Principal,
	AlertService
) {
	var $ctrl = this;
	var resource = IqdCalculation;
	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	var transition = $ctrl.transition;
	WarnIqdService.open();

  $ctrl.currentAccount = null;

  Principal.identity().then(account => {
    $ctrl.currentAccount = account;
    })

	$ctrl.allProjects = [];
	$http.get('api/projects', { params: { onlyUsed: true } }).then(response => {
		$ctrl.allProjects = response.data.content;
		let selectedProjectId = $ctrl.transitionParams ? $ctrl.transitionParams.project : null;
		$ctrl.project = $ctrl.allProjects.find(it => it.id == selectedProjectId);
	});

	$ctrl.transition = params => {
		transition(params);
		$ctrl.transitionParams = params;

		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);
		resource.query(
			{
				iqdtype: 'DEFAULT',
				road: params.road,
				campaign: params.campaign,
				project: params.project,
				sort: params.sort,
				page: params.page,
				size: params.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = () => {
		$state.go(
			$state.current,
			{
				page: 0,
				road: $ctrl.road ? $ctrl.road.id : null,
				project: $ctrl.project ? $ctrl.project.id : null,
				iqdtype: 'DEFAULT'
			},
			{
				reload: true
			}
		);
	};

	$ctrl.remove = id => {
		var entity = $ctrl.entities.find(e => e.id === id);
		resource.remove({ id: id }, () => {
			AlertService.success('entity.delete.message', {
				type: 'iqdCalculation',
				name: entity ? entity.name : ''
			});
			$state.reload();
		});
	};
}

app.component('iqdCalculationSearch', {
	templateUrl,
	controller: IqdCalculationSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCostTables: '<'
	}
});
